module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_ucsf-6d024115d179615fcd46802d03fb2d02.png";